import { createStationBreadcrumbItem } from '@app/components/base/stations/StationBreadcrumbLabel';
import { Page } from '@app/components/page/Page';
import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { FragmentIcon } from '@app/modules/fragments/components/FragmentIcon';
import { GetFragmentDto } from '@app/modules/fragments/fragment.types';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { BreadcrumbItem } from '@mi-front/ui';
import { useIntl } from 'react-intl';

export interface SocialExportUploadBreadcrumbsProps {
  fragment: GetFragmentDto;
}

/**
 * Breadcrumb trail for the fragment social upload page. Extends the fragment view trail
 * (module root + station) with the fragment itself, linked back to its view page.
 */
export function SocialExportUploadBreadcrumbs({ fragment }: SocialExportUploadBreadcrumbsProps) {
  const { $t } = useIntl();
  const findStation = useStationsFinder();
  // Stations come from the app-init cache; missing entries just shorten the trail.
  const station = findStation(fragment.stationId);

  const items: BreadcrumbItem[] = [
    {
      icon: <FragmentIcon fontSize="inherit" />,
      content: $t({
        id: 'fragments.listScreen.allFragments',
        defaultMessage: 'Fragmentos',
      }),
    },
    ...(station ? [createStationBreadcrumbItem(station, routeGenerator.list(station.slug))] : []),
    {
      content: fragment.title ?? fragment.id,
      href: routeGenerator.view(fragment.id),
    },
  ];

  return <Page.Breadcrumbs items={items} />;
}
